import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import FormFields from '@pages/Forms/FormFields';
import './sessionForm.css';
import HealthFacilitySearchMapPoc from '@components/common/Esrimap/HealthFacilitySearchMapPoc';
import FacilityESRIMap from '@components/common/Esrimap/MapWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { setMapLatLong, setMapManualLatLong, setMapManualLatLongClicked, setMapServicesCreatePolygon, setMapServicesPolygonForEdit } from '@store/actions/facilityGeoMapAction';
import { sessionPropsType } from '../vhnd-interface';
import Point from "@arcgis/core/geometry/Point.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import * as projection from "@arcgis/core/geometry/projection.js";
import { toast } from 'react-toastify';
import Button from '@components/common/Button';
import PlusSvgIcon from '@assets/svg_main/plus.svg';
import CrossIcon from '@assets/svg_main/CrossIcon.svg';
import InfoBar from '@components/common/InfoBars';
import { map_message, page_type } from '@constants/esriMapConstant';
import { buttonNames } from '@constants/appConstants';
import config from '@config/config';

const SessionForm = ({
    formData,
    formState,
    handleFormChange,
    handleSessionDetailsDataChangeOnMapFails,
    userLocationDetails,
    handleSessionDetailsCoverageArea,
    flow,
    sessionDetail
}: sessionPropsType) => {
    const newFormData = Object.assign({}, JSON.parse(JSON.stringify(formData)));
    delete newFormData.sessionSiteAddress;
    delete newFormData.sessionMap;
    delete newFormData.sessionSiteCoverageArea;
    const dispatch = useDispatch();
    const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);
    const facilityGeoMapref = useRef(facilityGeoMap);
    const [mapRender, setMapRender] = useState(false);
    const [mapRenderFromSearch, setMapRenderFromSearch] = useState(false);
    const location = useRef({ latitude: formState['lattitude'].value ? formState['lattitude'].value : '', longitude: formState['longitude'].value ? formState['longitude'].value : '' });
    const dtCode = useRef({ dtCode: (userLocationDetails && userLocationDetails.district_code) ? userLocationDetails?.district_code : '' });
    const selectedAddressValue: any = useRef<any>({ value: formState['sessionSiteAddress'].value ? formState['sessionSiteAddress'].value : '' });
    const selectedCoverageAreaValue: any = useRef<any>('');
    const selectedCoverageAreadata: any = useRef<any>('');
    const [addCoverageDisabled, setAddCoverageDisabled] = useState(true);
    const coverageAreaList = useRef<any[]>([]);
    const coverageAreaCoordinates = useRef<any[]>([]);

    useEffect(() => {
        facilityGeoMapref.current = facilityGeoMap;
    }, [facilityGeoMap]);

    const onCreateCoverageAreaPolygone = useCallback((type: any) => {
        const coverageAreaData: any[] = JSON.parse(JSON.stringify(coverageAreaList.current));
        const coordinates: any[] = [];
        coverageAreaData.forEach((element: any) => {
            coordinates.push(element?.locationDetail);
        });
        coordinates.push(coverageAreaData?.[0]?.locationDetail);
        coverageAreaCoordinates.current = coordinates;
        if (!facilityGeoMapref.current.mapServicesDown) {
            const latLong = ((flow == 'edit' || flow == 'duplicate') && !type) ? { latitude: formState['lattitude'].value ? Number(formState['lattitude'].value).toFixed(5) : '', longitude: formState['longitude'].value ? Number(formState['longitude'].value).toFixed(5) : '' } :
                { latitude: facilityGeoMapref.current.locationData.latitude ? Number(facilityGeoMapref.current.locationData.latitude).toFixed(5) : '', longitude: facilityGeoMapref.current.locationData.longitude ? Number(facilityGeoMapref.current.locationData.longitude).toFixed(5) : '' };
            location.current = latLong;
            setMapRender(!mapRender);
            dispatch(setMapServicesCreatePolygon(true));
        }
        dispatch(setMapServicesPolygonForEdit(false));
    }, []);

    useEffect(() => {
        coverageAreaList.current = formState['coverageArea'].value ? JSON.parse(JSON.stringify(formState['coverageArea'].value)) : [];
    }, [formState['coverageArea'].value]);

    useEffect(() => {
        if (facilityGeoMap.polygoneForEdit) {
            onCreateCoverageAreaPolygone('');
        }
    }, [facilityGeoMap.polygoneForEdit]);

    useEffect(() => {
        dispatch(setMapLatLong({ latitude: formState['lattitude'].value ? formState['lattitude'].value : '', longitude: formState['longitude'].value ? formState['longitude'].value : '' }));
    }, []);

    const onLocationChange = useCallback((locationData: any) => {
        dispatch(setMapLatLong({ latitude: locationData.latitude ? Number(locationData.latitude).toFixed(5) : '', longitude: locationData.longitude ? Number(locationData.longitude).toFixed(5) : '' }));
        handleFormChange(`${locationData.latitude ? Number(locationData.latitude).toFixed(5) : ''}`, 'lattitude', '', '', '');
        handleFormChange(`${locationData.longitude ? Number(locationData.longitude).toFixed(5) : ''}`, 'longitude', '', '', '');
        dispatch(setMapManualLatLong(false));
        dispatch(setMapManualLatLongClicked(false));
    }, []);

    const onSelectLocationChange = useCallback((locationData: any) => {
        if (!facilityGeoMapref.current.mapServicesDown && config.enableArcGISMap === 'ON') {
            location.current = { latitude: locationData.latitude ? Number(locationData.latitude).toFixed(5) : '', longitude: locationData.longitude ? Number(locationData.longitude).toFixed(5) : '' };
        }
        dispatch(setMapLatLong({ latitude: locationData.latitude ? Number(locationData.latitude).toFixed(5) : '', longitude: locationData.longitude ? Number(locationData.longitude).toFixed(5) : '' }));
        handleFormChange(`${locationData.latitude ? Number(locationData.latitude).toFixed(5) : ''}`, 'lattitude', '', '', '');
        handleFormChange(`${locationData.longitude ? Number(locationData.longitude).toFixed(5) : ''}`, 'longitude', '', '', '');
        handleFormChange(`${selectedAddressValue.current?.value}`, 'sessionSiteAddress', '', '', '');

    }, []);

    const onPostalCodeChange = useCallback((postalCodeData: any) => {
        handleFormChange(`${selectedAddressValue.current ? selectedAddressValue.current?.value : formState['sessionSiteAddress'].value ? formState['sessionSiteAddress'].value : ''}`, 'sessionSiteAddress', '', '', '');
    }, []);

    const onAddressChange = useCallback(() => {
        handleFormChange(`${selectedAddressValue.current?.value}`, 'sessionSiteAddress', '', '', '');
    }, []);

    const handleClearLatLongOnFormChange = useCallback((latitude: any, longitude: any, address: any) => {
        dispatch(setMapLatLong({ latitude: latitude, longitude: longitude }));
        handleFormChange(latitude, 'lattitude', '', '', '');
        handleFormChange(longitude, 'longitude', '', '', '');
        selectedAddressValue.current.value = address;
        handleFormChange(address, 'sessionSiteAddress', '', '', '');
    }, []);

    const setLocationDetailsToLoadWhileMapWork = useCallback((latitude: any, longitude: any, address: any) => {
        location.current = { latitude: latitude ? Number(latitude) : '', longitude: longitude ? Number(longitude) : '' };
        selectedAddressValue.current.value = address;
    }, []);

    const setLocationDetailsToLoadWhileMapDoseNotWork = useCallback((latitude: any, longitude: any, address: any) => {
        handleFormChange(`${latitude ? latitude : ''}`, 'lattitude', '', '', '');
        handleFormChange(`${longitude ? longitude : ''}`, 'longitude', '', '', '');
        dispatch(setMapLatLong({ latitude: latitude ? Number(latitude).toFixed(5) : '', longitude: longitude ? Number(longitude).toFixed(5) : '' }));
        selectedAddressValue.current.value = address;
        handleFormChange(selectedAddressValue.current?.value, 'sessionSiteAddress', '', '', '');
    }, []);


    const onLocationAddressChange = useCallback((data: any, key: any, id: any, option: any, code: any) => {
        const value = (data == undefined || data == null || data.length == 0 || data == false || data == '') ? '' : data;
        if (key == 'sessionHeld') {
            handleFormChange(value, key, id, option, code);
            if (value) {
                if (!facilityGeoMapref.current.mapServicesDown && config.enableArcGISMap === 'ON') {
                    if (flow == 'edit' || flow == 'duplicate') {
                        if (sessionDetail.is_session_held_at_facility === true) {
                            setLocationDetailsToLoadWhileMapWork(sessionDetail.session_latitude, sessionDetail.session_longitude, sessionDetail.session_site_address);
                        } else {
                            setLocationDetailsToLoadWhileMapWork(userLocationDetails.latitude, userLocationDetails.longitude, userLocationDetails.facility_address);
                        }
                    } else {
                        setLocationDetailsToLoadWhileMapWork(userLocationDetails.latitude, userLocationDetails.longitude, userLocationDetails.facility_address);
                    }
                } else {
                    if (flow == 'edit' || flow == 'duplicate') {
                        if (sessionDetail.is_session_held_at_facility === true) {
                            setLocationDetailsToLoadWhileMapDoseNotWork(sessionDetail.session_latitude, sessionDetail.session_longitude, sessionDetail.session_site_address);
                        } else {
                            setLocationDetailsToLoadWhileMapDoseNotWork(userLocationDetails.latitude, userLocationDetails.longitude, userLocationDetails.facility_address);
                        }
                    } else {
                        setLocationDetailsToLoadWhileMapDoseNotWork(userLocationDetails.latitude, userLocationDetails.longitude, userLocationDetails.facility_address);
                    }
                }
            } else {
                if (!facilityGeoMapref.current.mapServicesDown && config.enableArcGISMap === 'ON') {
                    if (flow == 'edit' || flow == 'duplicate') {
                        if (sessionDetail.is_session_held_at_facility === true) {
                            location.current = { latitude: '', longitude: '' };
                            handleClearLatLongOnFormChange('', '', '');
                        } else {
                            setLocationDetailsToLoadWhileMapWork(sessionDetail.session_latitude, sessionDetail.session_longitude, sessionDetail.session_site_address);
                        }
                    } else {
                        location.current = { latitude: '', longitude: '' };
                        handleClearLatLongOnFormChange('', '', '');
                    }
                } else {
                    if (flow == 'edit' || flow == 'duplicate') {
                        if (sessionDetail.is_session_held_at_facility === true) {
                            location.current = { latitude: '', longitude: '' };
                            handleClearLatLongOnFormChange('', '', '');
                        } else {
                            handleClearLatLongOnFormChange(sessionDetail.session_latitude, sessionDetail.session_longitude, sessionDetail.session_site_address);
                        }
                    } else {
                        location.current = { latitude: '', longitude: '' };
                        handleClearLatLongOnFormChange('', '', '');
                    }
                }
            }
        } else {
            handleFormChange(value, key, id, option, code);
        }

        if ((key === 'lattitude' || key === 'longitude') && !facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') {
            dispatch(setMapManualLatLong(true));
        }
    }, []);

    const onformFieldChange = useCallback((data: any) => {
        handleSessionDetailsDataChangeOnMapFails(data);
    }, []);

    const createPoint = useCallback((longitude: any, latitude: any) => {
        const point = new Point({
            longitude: longitude,
            latitude: latitude
        });

        return point;
    }, []);

    const onSelectCoverageArea = useCallback((data: any) => {
        selectedCoverageAreadata.current = data;
        const point = createPoint(data.locationDetail[0], data.locationDetail[1]);
        const projectedPiont: any = projection.project(point, facilityGeoMapref.current?.distFenceGeometry?.spatialReference);
        if (!geometryEngine.contains(facilityGeoMapref.current?.distFenceGeometry, projectedPiont)) {
            toast.error(map_message.sessionVhndCoverageMessage, {
                position: "top-center",
            });
            selectedCoverageAreaValue.current.value = '';
            selectedCoverageAreadata.current = '';
            onCoverageAreaChange();
            setAddCoverageDisabled(true);
        } else {
            setAddCoverageDisabled(false);
        }
    }, []);

    const onCoverageAreaChange = useCallback(() => {
        selectedCoverageAreaValue.current.value === '' ? setAddCoverageDisabled(true) : '';
        handleFormChange(`${selectedCoverageAreaValue.current.value}`, 'sessionSiteCoverageArea', '', '', '');
    }, []);

    const clearCoverageAreaDataAfterAdd = () => {
        selectedCoverageAreaValue.current.value = '';
        selectedCoverageAreadata.current = '';
        onCoverageAreaChange();
        setAddCoverageDisabled(true);
        dispatch(setMapServicesCreatePolygon(false));
    };

    const onCoverageAreaAdd = useCallback(() => {
        const coverageAreaData: { address: string }[] = JSON.parse(JSON.stringify(coverageAreaList.current));
        if (!coverageAreaData.some((cv: any) => (cv.address == selectedCoverageAreadata.current.address && (JSON.stringify(cv.locationDetail) === JSON.stringify(selectedCoverageAreadata.current.locationDetail))))) {
            coverageAreaData.push(selectedCoverageAreadata.current);
            coverageAreaList.current = JSON.parse(JSON.stringify(coverageAreaData));
            handleSessionDetailsCoverageArea(coverageAreaData, 'coverageArea');
            clearCoverageAreaDataAfterAdd();
        } else {
            toast.error(map_message.sessionAddCoverageMessage, {
                position: "top-center",
            });
            clearCoverageAreaDataAfterAdd();
        }
    }, []);

    const onClearCoverageArea = useCallback((index: any) => {
        const coverageAreaData: any[] = JSON.parse(JSON.stringify(coverageAreaList.current));
        coverageAreaData.splice(index, 1);
        coverageAreaList.current = JSON.parse(JSON.stringify(coverageAreaData));
        handleSessionDetailsCoverageArea(coverageAreaData, 'coverageArea');
        dispatch(setMapServicesCreatePolygon(false));
    }, []);


    return (
        <>
            <div className="create_session_details_page">
                <div className='autoPopulateText'>{`${userLocationDetails?.state_name} / ${userLocationDetails?.district_name} / ${userLocationDetails?.facility_name}`}</div>
                <form className="form_container_session_details">
                    <FormFields
                        formData={newFormData}
                        formState={formState}
                        handleFormChange={onLocationAddressChange}
                    />

                    {(((flow == 'edit' || flow == 'duplicate') && mapRender) || flow === 'create' ) && <div className={`map_wrapper ${formData.sessionMap['#isDisabled'] == true ? 'disabled' : ''}`}>
                        <FacilityESRIMap
                            selectedAddressValue={selectedAddressValue}
                            latitude={location.current.latitude}
                            longitude={location.current.longitude}
                            dtCode={dtCode.current}
                            onPostalCodeChange={onPostalCodeChange}
                            onLocationChange={onLocationChange}
                            onformFieldChange={onformFieldChange}
                            mapRender={mapRender}
                            mapRenderFromSearch={mapRenderFromSearch}
                            pageType={page_type.session_site_vhnd}
                            coverageAreaCoordinates={coverageAreaCoordinates.current}
                        />
                        <div className="attributionNotes">
                            Powered By <img src={`${config.root ? config.root : ''}/assets/images/NicBharatMaps.png`} alt="NicBharatMaps" style={{height:40}}/>
                        </div>
                    </div>}

                    <div key={'sessionSiteAddress'} className={`${'sessionSiteAddress'}_wrapper`}>
                        <HealthFacilitySearchMapPoc
                            selectedAddressValue={selectedAddressValue}
                            formData={formData}
                            formState={formState}
                            objkey={'sessionSiteAddress'}
                            labelName={"Session Site Address"}
                            required={formData['sessionSiteAddress']['#required'] || false}
                            disabled={formData['sessionSiteAddress']['#isDisabled'] || false}
                            onSelectLocationChange={onSelectLocationChange}
                            onAddressChange={onAddressChange}
                            inputType={formState['sessionSiteAddress'].isError ? 'error' : 'general'}
                            errorMessage={formState['sessionSiteAddress'].message}
                            mapRender={mapRenderFromSearch}
                            setMapRender={setMapRenderFromSearch}
                            pageFlow={'vhnd'}
                        />
                    </div>
                    <div key={'sessionSiteCoverageArea'} className={`${'sessionSiteCoverageArea'}_wrapper`}>
                        <div className='coverageAreaBox'>
                            <HealthFacilitySearchMapPoc
                                selectedAddressValue={selectedCoverageAreaValue}
                                formData={formData}
                                formState={formState}
                                objkey={'sessionSiteCoverageArea'}
                                labelName={"Coverage Area"}
                                required={formData['sessionSiteCoverageArea']['#required'] || false}
                                disabled={formData['sessionSiteCoverageArea']['#isDisabled'] || false}
                                pageFlow={'vhnd'}
                                polygonWork={true}
                                onSelectCoverageArea={onSelectCoverageArea}
                                onCoverageAreaChange={onCoverageAreaChange}
                            />
                            <Button
                                onClick={onCoverageAreaAdd}
                                disabled={addCoverageDisabled}
                                id="add-coverage"
                                buttonName={'Add'}
                                colorType={'primary'}
                                icon={<PlusSvgIcon />}
                                iconPosition={'left'}
                            />
                        </div>
                        <div className='note_text'><i>Note: </i> Atleast three areas should be added to create coverage.</div>
                    </div>

                    <div key={'sessionSiteCoverageAreaList'} className={`${'sessionSiteCoverageAreaList'}_wrapper`}>
                        <div className='coverageAreaListBox'>
                            <div className={`addressListContainer ${(!facilityGeoMapref.current.mapServicesDown && config.enableArcGISMap === 'ON') ? '' : 'disable'}`}>
                                {coverageAreaList.current.length > 0 && coverageAreaList.current?.map((element: any, index: number) => {
                                    return (<div className='listItem' key={index}>
                                        <div className='itemText'>{element?.address}</div>
                                        <span style={{ cursor: 'pointer' }} onClick={() => onClearCoverageArea(index)}><CrossIcon /></span>
                                    </div>)
                                })}
                            </div>
                        </div>
                        <div className={`coverageAreaActionBox ${(!facilityGeoMapref.current.mapServicesDown && config.enableArcGISMap === 'ON') ? '' : 'disable'}`} style={{ justifyContent: formState['coverageArea'].isError ? 'space-between' : 'flex-end' }}>
                            {formState['coverageArea'].isError ? <InfoBar
                                variant="danger"
                                message={formState['coverageArea'].message ? formState['coverageArea'].message : ''}
                                className="input_field_class"
                            /> : <></>}
                            <Button
                                onClick={() => onCreateCoverageAreaPolygone('clicked')}
                                disabled={coverageAreaList.current.length < 3}
                                id="create-polygon"
                                buttonName={buttonNames.coverageArea}
                                colorType={'primary'}
                                icon={<PlusSvgIcon />}
                                iconPosition={'left'}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
};

const MemoizedSessionDetails = memo(SessionForm);
MemoizedSessionDetails.displayName = "SessionForm"

export default MemoizedSessionDetails;